module.exports = __webpack_public_path__ + "static/img/Logo-gosell.34f6bf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/dashboard/Logo-gosell.png
// module id = pFvL
// module chunks = 134